import { BriefingFormModel } from "pages/BriefingForm/interfaces";

export const createBriefingFormUpdateModel = (getValues: Function): BriefingFormModel => {
    return {
        salesRep: {
            name: getValues("salesRep.name"),
            email: getValues("salesRep.email"),
            phone: getValues("salesRep.phone"),
        },
        adDesign: {
            complexity: getValues("adDesign.complexity"),
            type: getValues("adDesign.type"),
        },
        adSize: {
            sizes: getValues("adSize.sizes"),
            type: getValues("adSize.type"),
        },
        digitalBrief: {
            callToAction: getValues("digitalBrief.callToAction"),
            ioNumber: getValues("digitalBrief.ioNumber"),
            landingURL: getValues("digitalBrief.landingURL"),
            specialInstructions: getValues("digitalBrief.specialInstructions"),
            assets: getValues("digitalBrief.assets"),
        },
    };
};
